import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';

//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

//import Components
import LanguageDropdown from '../Components/Common/LanguageDropdown';
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';
import UserActivityOffcanvas from '../Components/Common/UserActivityOffcanvas';
import ChatDrawer from '../Components/Common/ChatDrawer';
import { getChatUnread } from '../helpers/chat_helper';

import { changeSidebarVisibility } from '../slices/thunks';
import { useSelector, useDispatch, shallowEqual } from "react-redux";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
    const dispatch = useDispatch();

    const { sidebarVisibilitytype, user } = useSelector(state => ({
        sidebarVisibilitytype: state.Layout.sidebarVisibilitytype,
        user: state.Login.user
    }), shallowEqual);

    const authUser = user || JSON.parse(localStorage.getItem("authUser")) || {};

    const [isActivityOpen, setIsActivityOpen] = useState(false);
    const toggleActivity = () => setIsActivityOpen(!isActivityOpen);

    // ── Чат ──
    // Уншаагүйн тоог цонх ХААЛТТАЙ байхад ч мэдэхийн тулд header өөрөө асууна.
    // Цонх нээлттэй үед ChatDrawer нь илүү шинэ тоог `onUnreadChange`-ээр өгнө.
    const [isChatOpen, setIsChatOpen] = useState(false);
    const toggleChat = () => setIsChatOpen((v) => !v);
    const [chatUnread, setChatUnread] = useState(0);

    const pollUnread = useCallback(async () => {
        if (document.hidden) return;
        try {
            const r = await getChatUnread();
            setChatUnread((r && r.total) || 0);
        } catch (e) { /* сүлжээний түр зуурын алдааг чимээгүй өнгөрөөнө */ }
    }, []);

    useEffect(() => {
        if (!authUser || !authUser._id) return undefined;
        pollUnread();
        const t = setInterval(pollUnread, 20000);
        return () => clearInterval(t);
    }, [authUser, pollUnread]);

    const [search, setSearch] = useState(false);
    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767) {
            const hamburgerIcon = document.querySelector(".hamburger-icon");
            if (hamburgerIcon) {
                hamburgerIcon.classList.toggle('open');
            }
        }

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical and semibox menu
        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }


        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <img src={logoSm} alt="" height="30" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={logoDark} alt="" height="30" />
                                    </span>
                                </Link>

                                <Link to="/" className="logo logo-light">
                                    <span className="logo-sm">
                                        <img src={logoSm} alt="" height="30" />
                                    </span>
                                    <span className="logo-lg">
                                        <img src={logoLight} alt="" height="30" />
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>

                        <div className="d-flex align-items-center">

                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />

                            {/* Dark/Light Mode set */}
                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />

                            {/* User Activity Dashboard Button for SuperAdmins */}
                            {authUser.role === "SuperAdmin" && (
                                <div className="ms-1 header-item d-none d-sm-flex">
                                    <button
                                        onClick={toggleActivity}
                                        type="button"
                                        className="btn btn-icon btn-topbar btn-ghost-primary rounded-circle"
                                        title="Хэрэглэгчдийн идэвхи"
                                    >
                                        <i className='ri-group-line fs-22'></i>
                                    </button>
                                </div>
                            )}

                            {/* Чат — баруун талаас гарах цонх */}
                            <div className="ms-1 header-item d-none d-sm-flex">
                                <button
                                    onClick={toggleChat}
                                    type="button"
                                    className="btn btn-icon btn-topbar btn-ghost-primary rounded-circle position-relative"
                                    title="Чат"
                                >
                                    <i className='ri-chat-3-line fs-22'></i>
                                    {chatUnread > 0 && (
                                        <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                                            {chatUnread > 99 ? '99+' : chatUnread}
                                            <span className="visually-hidden">уншаагүй мессеж</span>
                                        </span>
                                    )}
                                </button>
                            </div>

                            {/* NotificationDropdown */}
                            <NotificationDropdown />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>

            {/* Чат — БҮХ хэрэглэгчид нээлттэй. Хэнтэй чатлах эрхтэйг сервэр шийднэ. */}
            <ChatDrawer
                isOpen={isChatOpen}
                toggle={toggleChat}
                onUnreadChange={setChatUnread}
            />

            {/* Offline/Online User Activity Offcanvas Component */}
            {authUser.role === "SuperAdmin" && (
                <UserActivityOffcanvas isOpen={isActivityOpen} toggle={toggleActivity} />
            )}
        </React.Fragment>
    );
};

export default Header;